import React, { Component } from "react";

export default class ReverseDigitSpan extends Component {
  render() {
    var {
      reverse_digit_span_trial1,
      reverse_digit_span_trial2,
      reverse_digit_span_trial2,
      reverse_digit_span_trial3,
      reverse_digit_span_trial4,
      reverse_digit_span_trial5,
      reverse_digit_span_trial6,
      reverse_digit_span_trial7,
      reverse_digit_span_trial8,
      reverse_digit_span_trial9,
      reverse_digit_span_trial10,
      reverse_digit_span_trial11,
      reverse_digit_span_trial12,
      reverse_digit_span_score,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-10">
          <br />
          <ul style={{ paddingLeft: 20, fontSize: 19 }}>
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Numbers should be read out at a pace of 1 number per second.
                </li>
                <li style={{ listStyle: "circle" }}>
                  If the participant makes an error on the practice trial, they
                  are corrected and the first trial of the test begins.
                </li>
                <li style={{ listStyle: "circle" }}>
                  If the participant fails the first two items then the test is
                  scored at 0 and no further items are attempted.
                </li>
                <li style={{ listStyle: "circle" }}>
                  In order to score a trial of a line as correct, participant
                  must accurately recall all items in reverse order.
                </li>
                <li style={{ listStyle: "circle" }}>
                  No score is given for individual numbers correctly recalled in
                  an incorrectly recalled sequence.
                </li>
                <li style={{ listStyle: "circle" }}>
                  If the participant gets at least one trial of a line correct,
                  move on to the next line.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Self-corrections are allowed; only the final answer is taken
                  for scoring.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Stop when person gets both trials of a line wrong.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Scoring:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Score is total number of trials achieved correctly (out of 12)
                </li>
                <li style={{ listStyle: "circle" }}>
                  In order to score a trial of a line as correct, participant
                  must accurately recall all items in reverse order.
                </li>
                <li style={{ listStyle: "circle" }}>
                  No score is given for individual numbers correctly recalled in
                  an incorrectly recalled sequence.
                </li>
                <li style={{ listStyle: "circle" }}>
                  If the participant gets at least one trial of a line correct,
                  move on to the next line.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Self-corrections are allowed; only the final answer is taken
                  for scoring.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Stop when person gets both trials of a line wrong.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  I am going to say some numbers and I would like you to say
                  them back to me in reverse order. For example, if I say ‘2 3
                  4’, you should say ‘4 3 2’. Let’s have a practice. If I say ‘7
                  1 9’, what would you say?
                </li>
                <li style={{ listStyle: "circle" }}>
                  The number sequences will increase in length at the start of
                  each line of a trial.
                  <ul>
                    <li style={{ listStyle: "circle" }}>
                      Stop when person gets both trials of a line wrong. Score
                      total number of trials correct
                    </li>
                  </ul>
                </li>
                <li>
                  <table
                    className="answer-table table table-responsive"
                    cellPadding={9}
                  >
                    <tbody>
                      <tr>
                        <th style={{ minWidth: 56 }} className="trial">
                          Trial
                        </th>
                        <th style={{ minWidth: 118 }}></th>
                        <th style={{ minWidth: 71 }}>Check</th>
                        <th style={{ minWidth: 56 }} className="trial">
                          Trial
                        </th>
                        <th style={{ minWidth: 118 }}></th>
                        <th style={{ minWidth: 71 }}>Check</th>
                      </tr>
                      <tr>
                        <td className="trial">1</td>
                        <td>2 6</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial1 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial1"
                          />
                        </td>
                        <td className="trial">2</td>
                        <td>5 8</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial2 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial2"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="trial">3</td>
                        <td>9 3 5</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial3 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial3"
                          />
                        </td>
                        <td className="trial">4</td>
                        <td>4 1 6</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial4 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial4"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="trial">5</td>
                        <td>7 2 8 4 </td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial5 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial5"
                          />
                        </td>
                        <td className="trial">6</td>
                        <td>9 5 7 3</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial6 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial6"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="trial">7</td>
                        <td>6 9 4 2 1</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial7 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial7"
                          />
                        </td>
                        <td className="trial">8</td>
                        <td>8 3 2 5 6</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial8 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial8"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="trial">9</td>
                        <td>8 1 3 5 7 9</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial9 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial9"
                          />
                        </td>
                        <td className="trial">10</td>
                        <td>3 6 2 7 3 4</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial10 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial10"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="trial">11</td>
                        <td>1 6 9 3 5 8 6</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial11 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial11"
                          />
                        </td>
                        <td className="trial">12</td>
                        <td>2 3 6 8 4 9 2</td>
                        <td>
                          <input
                            readOnly
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              reverse_digit_span_trial12 == "1" ? true : false
                            }
                            name="reverse_digit_span_trial12"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="col-lg-2 pt-4" style={{ borderLeft: "1px solid #000" }}>
          <div>
            <span className="fs-19">Score (0-12) </span>
            <input
              disabled
              type="number"
              name="reverse_digit_span_score"
              value={reverse_digit_span_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
